import React, { Component } from 'react';
import './DrugPage.css';
import Page from '../../components/page/Page';
import models from '../../model/models';
import UpdateTitle from '../../components/updateTitle/UpdateTitle';
import DrugTypeSummary from "../../cards/drugTypeSummary/DrugTypeSummary";
import DrugsPaginatedCard from "../../cards/drugPaginatedCard/DrugsPaginatedCard";
import DrugOrderFormsPaginatedCard from "../../cards/drugOrderFormsPaginatedCard/DrugOrderFormsPaginatedCard";

export default class DrugPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			search: '',
			user_group: {}
		};
	}

	componentDidMount = () => {
		this.groupSubscribeId = models.user_group.onChange(this._updateUserGroup);
		this.typeSubId = models.drug_type.onChange(this._updateDrugTypes);
	};

	componentWillUnmount = () => {
		models.drug.unsubscribe(this.subscribeId);
		models.user_group.unsubscribe(this.groupSubscribeId);
		models.drug_type.unsubscribe(this.typeSubId);
	};

	_updateUserGroup = () => {
		let user_group = models.user_group.obj();
		this.setState({ user_group });
	};


	_updateDrugTypes = () => {
		let types = models.drug_type.allowed();
		this.setState({ types });
	};

	render() {
		return (
			<Page className="g-drug-page">
				<UpdateTitle newTitle="Drugs" originalTitle="LogRx" />
				<DrugTypeSummary types={this.state.types} user_group={this.state.user_group} includePar />
				<DrugsPaginatedCard
					title="Drugs"
					showUnit={true}
					pageSize={250}
				filter={{used_drugs:false}}/>
				<DrugsPaginatedCard
					displayNewDrugButton={false}
					title="Used Drugs"
					showUnit={true}
					pageSize={250}
					filter={{only_used_drugs: true}}/>
				<DrugOrderFormsPaginatedCard
					title="Drug Order Forms"
					displayNewFormButton={true}
					pageSize={250}
				/>
			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/drugPage/DrugPage.jsx